var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcSmarttvActive = function SvgIcSmarttvActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-smarttv-active_svg__ic-smarttv-active",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 4H4C2.3 4 1 5.3 1 7V23C1 24.7 2.3 26 4 26H10V30H22V26H28C29.7 26 31 24.7 31 23V7C31 5.3 29.7 4 28 4ZM15 12H12V20H10V12H7V10H15V12ZM21.7 20H19.3L16 10H18.1L20.5 17.3L22.9 10H25L21.7 20Z",
    fill: "#FF6400"
  })));
};
export default SvgIcSmarttvActive;